import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputAdornment,
  Chip,
  Alert,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { 
  Download, 
  Print, 
  ZoomIn, 
  ZoomOut, 
  Title, 
  CheckCircle, 
  ArrowBack,
  Visibility,
  Close as CloseIcon,
  Home
} from "@mui/icons-material";
import { MdOutlineDesignServices, MdFormatListBulletedAdd, MdSpellcheck } from "react-icons/md";
import { FaFileAlt } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";

import DesignFormattingComponent from "./DesignFormattingPage";
import Resume1 from "../DuplicateResume/Resume1";
import Resume2 from "../DuplicateResume/Resume2";
import Resume3 from "../DuplicateResume/Resume3";
import Resume4 from "../DuplicateResume/Resume4";
import Resume5 from "../DuplicateResume/Resume5";
import Resume6 from "../DuplicateResume/Resume6";
import Resume7 from "../DuplicateResume/Resume7";
import Resume8 from "../DuplicateResume/Resume8";
import Resume9 from "../DuplicateResume/Resume9";
import Resume10 from "../DuplicateResume/Resume10";
import Resume11 from "../DuplicateResume/Resume11";
import Resume12 from "../DuplicateResume/Resume12";
import Resume13 from "../DuplicateResume/Resume13";
import Resume14 from "../DuplicateResume/Resume14";
import Resume15 from "../DuplicateResume/Resume15";
import Resume16 from "../DuplicateResume/Resume16";
import Resume17 from "../DuplicateResume/Resume17";
import Resume18 from "../DuplicateResume/Resume18";
import Resume19 from "../DuplicateResume/Resume19";
import Resume20 from "../DuplicateResume/Resume20";
import Resume21 from "../DuplicateResume/Resume21";
import Resume22 from "../DuplicateResume/Resume22";
import Resume23 from "../DuplicateResume/Resume23";
import Resume24 from "../DuplicateResume/Resume24";
import Resume25 from "../DuplicateResume/Resume25";
import Resume26 from "../DuplicateResume/Resume26";
import Resume27 from "../DuplicateResume/Resume27";
import Resume28 from "../DuplicateResume/Resume28";
import Resume29 from "../DuplicateResume/Resume29";
import Resume30 from "../DuplicateResume/Resume30";
import Resume31 from "../DuplicateResume/Resume31";
import Resume32 from "../DuplicateResume/Resume32";
import Resume33 from "../DuplicateResume/Resume33";
import Resume34 from "../DuplicateResume/Resume34";
import Resume35 from "../DuplicateResume/Resume35";
import Resume36 from "../DuplicateResume/Resume36";
import Resume37 from "../DuplicateResume/Resume37";
import Resume38 from "../DuplicateResume/Resume38";
import Resume39 from "../DuplicateResume/Resume39";
import Resume40 from "../DuplicateResume/Resume40";
import Resume41 from "../DuplicateResume/Resume41";
import Resume42 from "../DuplicateResume/Resume42";
import Resume43 from "../DuplicateResume/Resume43";
import Resume44 from "../DuplicateResume/Resume44";
import Resume45 from "../DuplicateResume/Resume45";
import Resume46 from "../DuplicateResume/Resume46";
import Resume47 from "../DuplicateResume/Resume47";
import Resume48 from "../DuplicateResume/Resume48";
import Resume49 from "../DuplicateResume/Resume49";
import Resume50 from "../DuplicateResume/Resume50";
import TemplatesComponent from "./TemplatesComponent";
import AddSectionComponent from "./AddSectionComponent";
import SpellCheckComponent from "./SpellCheck";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

// Add this mapping of template components
const templateComponents = {
  1: Resume1,
  2: Resume2,
  3: Resume3,
  4: Resume4,
  5: Resume5,
  6: Resume6,
  7: Resume7,
  8: Resume8,
  9: Resume9,
  10: Resume10,
  11: Resume11,
  12: Resume12,
  13: Resume13,
  14: Resume14,
  15: Resume15,
  16: Resume16,
  17: Resume17,
  18: Resume18,
  19: Resume19,
  20: Resume20,
  21: Resume21,
  22: Resume22,
  23: Resume23,
  24: Resume24,
  25: Resume25,
  26: Resume26,
  27: Resume27,
  28: Resume28,
  29: Resume29,
  30: Resume30,
  31: Resume31,
  32: Resume32,
  33: Resume33,
  34: Resume34,
  35: Resume35,
  36: Resume36,
  37: Resume37,
  38: Resume38,
  39: Resume39,
  40: Resume40,
  41: Resume41,
  42: Resume42,
  43: Resume43,
  44: Resume44,
  45: Resume45,
  46: Resume46,
  47: Resume47,
  48: Resume48,
  49: Resume49,
  50: Resume50,
};

// ─────────────────────────────────────────────────────────────────────────────
// FIXED HELPER: capture all .resume-page elements at true scale=1
// so html2canvas is NOT affected by the CSS zoom transform on #resume-preview.
// Spell-check underlines are hidden during capture and fully restored after.
// ─────────────────────────────────────────────────────────────────────────────
const captureResumePages = async (resumeElement) => {
  // 1. Remove scale transform before capturing
  const originalTransform = resumeElement.style.transform;
  const originalTransformOrigin = resumeElement.style.transformOrigin;
  resumeElement.style.transform = "scale(1)";
  resumeElement.style.transformOrigin = "top left";

  // 2. Temporarily hide spell-check highlights so they don't appear in output
  const highlighted = resumeElement.querySelectorAll(".spell-error");
  const originalStyles = [];
  highlighted.forEach((el) => {
    originalStyles.push(el.getAttribute("style"));
    el.style.textDecoration = "none";
  });

  // 3. Wait two animation frames so the DOM fully repaints at the new transform
  await new Promise((res) =>
    requestAnimationFrame(() => requestAnimationFrame(res))
  );

  const pages = resumeElement.querySelectorAll(".resume-page");
  const canvases = [];

  if (pages.length > 0) {
    for (const page of pages) {
      const canvas = await html2canvas(page, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        logging: false,
        imageTimeout: 15000,
        removeContainer: true,
      });
      canvases.push(canvas);
    }
  } else {
    // Robust fallback: if a custom template doesn't specify `.resume-page` class wrappers,
    // capture the entire visual preview element as a single cohesive canvas page.
    const canvas = await html2canvas(resumeElement, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: "#ffffff",
      logging: false,
      imageTimeout: 15000,
      removeContainer: true,
    });
    canvases.push(canvas);
  }

  // 4. Restore original transform and spell-error styles
  resumeElement.style.transform = originalTransform;
  resumeElement.style.transformOrigin = originalTransformOrigin;
  highlighted.forEach((el, i) => {
    if (originalStyles[i]) {
      el.setAttribute("style", originalStyles[i]);
    } else {
      el.style.textDecoration = "wavy underline red";
    }
  });

  return canvases;
};

const ResumeEditor = () => {
  const [selectedMenu, setSelectedMenu] = useState("design");
  const [downloadDialogOpen, setDownloadDialogOpen] = useState(false);
  const [fileName, setFileName] = useState("Resume");
  const [fileFormat, setFileFormat] = useState("pdf");
  const [resumeName, setResumeName] = useState("My Resume");
  const [resumeNameDialogOpen, setResumeNameDialogOpen] = useState(false);
  const [scale, setScale] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const [resumeContent, setResumeContent] = useState(null);
  const [misspelledWords, setMisspelledWords] = useState([]);
  const [appliedCorrections, setAppliedCorrections] = useState([]);
  const [exporting, setExporting] = useState(false);
  const [finishDialogOpen, setFinishDialogOpen] = useState(false);
  const [mobileViewTab, setMobileViewTab] = useState(0); // 0 = Edit, 1 = Preview

  // ── NEW: Preview Dialog state (mirrors ContactForm's openPreviewDialog) ──────
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [previewScale, setPreviewScale] = useState(0.85);
  // ─────────────────────────────────────────────────────────────────────────────

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Get the selected theme from navigation state
  const initialTheme = location.state?.selectedTheme || "#0951b0ff";
  
  // State for design and template settings
  const [designSettings, setDesignSettings] = useState({
    color: typeof initialTheme === "string" ? initialTheme : 
           initialTheme.primary || initialTheme.highlight || "#0951b0ff",
    font: "EB Garamond",
    fontSize: "14px",
    fontStyle: "normal",
    headingSize: "24px",
    sectionSpacing: 10,
    paragraphSpacing: 10,
    lineSpacing: 20,
    topBottomMargin: 20,
    sideMargins: 20,
    paragraphIndent: 0,
    lineWeight: 1,
    pageSize: "A4"
  });
  
  // Initialize selectedTemplate directly from navigation state
  const initialTemplate = location.state?.selectedTemplate || 1;
  const [selectedTemplate, setSelectedTemplate] = useState(initialTemplate);

  // Handle template and theme selection from navigation state
  useEffect(() => {
    if (location.state) {
      if (location.state.selectedTemplate) {
        setSelectedTemplate(location.state.selectedTemplate);
      }
      if (location.state.selectedTheme) {
        const th = location.state.selectedTheme;
        setDesignSettings(prev => ({
          ...prev,
          color: typeof th === "string" ? th : 
                 th.primary || th.highlight || prev.color
        }));
      }
    }
  }, [location.state]);

  // Handle template selection - all templates are free now
  const handleTemplateSelect = (templateNumber) => {
    setSelectedTemplate(templateNumber);
  };

  // Get reference to resume content for spell checking
  useEffect(() => {
    const content = document.getElementById("resume-preview");
    if (content) {
      setResumeContent(content);
    }
  }, [selectedTemplate, selectedMenu]);

  // Helper functions for spell check corrections
  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

  const applyCorrectionsToDOM = (element, correctionsList) => {
    if (!element || !correctionsList || correctionsList.length === 0) return;

    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: (node) => {
          const parent = node.parentElement;
          if (parent && (parent.tagName === 'SCRIPT' || parent.tagName === 'STYLE')) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    const nodesToUpdate = [];
    let node;
    while ((node = walker.nextNode())) {
      let hasMatch = false;
      for (const c of correctionsList) {
        try {
          const regex = new RegExp(`\\b${escapeRegExp(c.word)}\\b`, "g");
          if (regex.test(node.textContent)) {
            hasMatch = true;
            break;
          }
        } catch (e) {}
      }
      if (hasMatch) {
        nodesToUpdate.push(node);
      }
    }

    nodesToUpdate.forEach((textNode) => {
      let text = textNode.textContent;
      correctionsList.forEach((c) => {
        try {
          const regex = new RegExp(`\\b${escapeRegExp(c.word)}\\b`, "g");
          text = text.replace(regex, c.suggestion);
        } catch (e) {}
      });
      textNode.textContent = text;
    });
  };

  // Fetch saved spell corrections on mount
  useEffect(() => {
    let mounted = true;
    const fetchCorrections = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch("https://resume-maker-lc.onrender.com/api/spellcorrections", {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        });
        const data = await res.json();
        if (!mounted || !data || !data.corrections) return;
        setAppliedCorrections(data.corrections);
      } catch (err) {
        console.error("Failed to load saved corrections", err);
      }
    };

    fetchCorrections();
    return () => {
      mounted = false;
    };
  }, []);

  // Observe DOM changes on resume-preview and apply corrections automatically
  useEffect(() => {
    const el = document.getElementById("resume-preview");
    if (!el || appliedCorrections.length === 0) return;

    const apply = (obs) => {
      if (obs) obs.disconnect();
      applyCorrectionsToDOM(el, appliedCorrections);
      if (obs) {
        obs.observe(el, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
    };

    // Apply immediately
    apply(null);

    const observer = new MutationObserver((mutations, obs) => {
      apply(obs);
    });

    observer.observe(el, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [appliedCorrections, resumeContent]);

  // Handle highlighting misspelled words in the resume
  const handleHighlightErrors = (errors) => {
    setMisspelledWords(errors);
    
    if (!resumeContent) return;
    
    // Remove any existing highlights
    const highlightedElements = resumeContent.querySelectorAll('.spell-error');
    highlightedElements.forEach(el => {
      const parent = el.parentNode;
      if (parent) {
          parent.innerHTML = parent.innerHTML.replace(
              `<span class="spell-error" style="text-decoration: wavy underline red;">${el.textContent}</span>`,
              el.textContent
          );
      }
    });
    
    // Add new highlights
    errors.forEach(error => {
      highlightText(resumeContent, error.original, error.word);
    });
  };
  
  // Helper function to highlight text (simplified implementation)
  const highlightText = (element, originalText, wordToHighlight) => {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);
    let node;
    
    while (node = walker.nextNode()) {
      if (node.parentElement && node.parentElement.closest('#resume-preview') === element && node.textContent.includes(originalText)) {
        const parent = node.parentNode;
        if (parent && !parent.classList.contains('spell-error') && parent.tagName !== 'SCRIPT' && parent.tagName !== 'STYLE') {
          const html = parent.innerHTML;
          const regex = new RegExp(`(?<!<[^>]*>)(${originalText})(?![^<]*>)`, 'g');
          
          if (html.includes(originalText) && !html.includes('spell-error')) {
              const newHtml = html.replace(
                regex,
                `<span class="spell-error" style="text-decoration: wavy underline red;">$1</span>`
              );
              parent.innerHTML = newHtml;
          }
        }
      }
    }
  };

  // Handle text replacement from spell check
  const handleSpellCorrection = (originalWord, newWord) => {
    if (!resumeContent) return;
    
    const highlightedElements = resumeContent.querySelectorAll('.spell-error');
    
    highlightedElements.forEach(el => {
        if (el.textContent === originalWord) {
            const parent = el.parentNode;
            if (parent) {
                el.outerHTML = newWord;
            }
        }
    });
  };

  // ─────────────────────────────────────────────────────────────────────────
  // FIXED PRINT HANDLER
  // ─────────────────────────────────────────────────────────────────────────
  const handlePrint = async () => {
    const resumeElement = document.getElementById("resume-preview");
    if (!resumeElement) return;

    const canvases = await captureResumePages(resumeElement);
    if (!canvases.length) return;

    const printWindow = window.open("", "_blank");
    if (!printWindow) {
      alert("Popup blocked. Please allow popups for this site and try again.");
      return;
    }

    const imgTags = canvases
      .map(
        (c) =>
          `<img src="${c.toDataURL("image/png")}" style="width:100%;display:block;page-break-after:always;" />`
      )
      .join("\n");

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Print Resume - ${resumeName}</title>
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; }
            @page { margin: 0; size: A4; }
            body { background: #fff; }
            img { max-width: 210mm; }
            @media print {
              body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
            }
          </style>
        </head>
        <body>${imgTags}</body>
      </html>
    `);
    printWindow.document.close();

    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.onafterprint = () => printWindow.close();
      }, 500);
    };
  };
  
  // Save download history
  const saveDownloadHistory = async (format, name, fileSize) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const downloadData = {
        templateId: selectedTemplate,
        fileName: name,
        fileFormat: format,
        fileSize: fileSize,
        themeColor: designSettings.color,
        downloadedAt: new Date().toISOString()
      };

      await axios.post(
        "https://resume-maker-lc.onrender.com/api/resumes/save-download",
        downloadData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    } catch (error) {
      console.error("Error saving download history:", error);
    }
  };
  
  // ─────────────────────────────────────────────────────────────────────────
  // FIXED DOWNLOAD HANDLER
  // ─────────────────────────────────────────────────────────────────────────
  const handleDownload = async (format) => {
    const resumeElement = document.getElementById("resume-preview");
    if (!resumeElement) return;

    setExporting(true);
    await new Promise(res => setTimeout(res, 400));
    
    let fileSize = 0;

    try {
      if (format === "pdf" || format === "png") {
        const canvases = await captureResumePages(resumeElement);

        if (!canvases.length) {
          alert("Could not find resume pages. Please try again.");
          return;
        }

        if (format === "pdf") {
          const pageSize = designSettings.pageSize?.toLowerCase() || "a4";
          const pdf = new jsPDF("p", "mm", pageSize);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();

          canvases.forEach((canvas, i) => {
            if (i > 0) pdf.addPage();

            const imgData = canvas.toDataURL("image/png");
            pdf.addImage(
              imgData, "PNG",
              0, 0,
              pdfWidth, pdfHeight,
              undefined, "FAST"
            );
          });

          const pdfBlob = pdf.output("blob");
          fileSize = pdfBlob.size;
          pdf.save(`${fileName}.pdf`);
          
        } else if (format === "png") {
          canvases.forEach((canvas, i) => {
            const link = document.createElement("a");
            link.href = canvas.toDataURL("image/png");
            link.download =
              canvases.length === 1
                ? `${fileName}.png`
                : `${fileName}-page-${i + 1}.png`;
            setTimeout(() => link.click(), i * 600);
          });

          if (canvases.length > 1) {
            alert(`Downloading ${canvases.length} PNG files. Please check your downloads folder.`);
          }
        }
      } else if (format === "doc" || format === "docx") {
        const highlighted = resumeElement.querySelectorAll(".spell-error");
        const originalStyles = [];
        highlighted.forEach((el) => {
          originalStyles.push(el.getAttribute("style"));
          el.style.textDecoration = "none";
        });

        const htmlContent = resumeElement.innerHTML;

        highlighted.forEach((el, i) => {
          if (originalStyles[i]) {
            el.setAttribute("style", originalStyles[i]);
          } else {
            el.style.textDecoration = "wavy underline red";
          }
        });

        let styles = "";
        try {
          const styleSheets = document.styleSheets;
          for (let i = 0; i < styleSheets.length; i++) {
            const sheet = styleSheets[i];
            const rules = sheet.cssRules || sheet.rules;
            if (rules) {
              for (let j = 0; j < rules.length; j++) {
                styles += rules[j].cssText + "\n";
              }
            }
          }
        } catch (e) {
          console.warn("Could not read style rules: ", e);
        }

        const styleTags = document.querySelectorAll("style");
        styleTags.forEach(tag => {
          styles += tag.innerHTML + "\n";
        });

        const docHtml = `
          <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns="http://www.w3.org/TR/REC-html40">
          <head>
            <meta charset="utf-8">
            <title>${fileName}</title>
            <style>
              ${styles}
              body {
                font-family: 'Arial', sans-serif;
                margin: 0;
                padding: 0;
              }
              .resume-page {
                box-shadow: none !important;
                margin: 0 auto !important;
                border: none !important;
                page-break-after: always;
              }
            </style>
          </head>
          <body>
            ${htmlContent}
          </body>
          </html>
        `;

        const blob = new Blob(['\ufeff' + docHtml], {
          type: 'application/msword'
        });

        fileSize = blob.size;

        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${fileName}.${format}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }

      await saveDownloadHistory(format, fileName, fileSize);

    } catch (err) {
      console.error("Download error:", err);
      alert("Something went wrong while generating the file. Please try again.");
    } finally {
      setExporting(false);
      setDownloadDialogOpen(false);
    }
  };
  
  // Handle zoom in
  const handleZoomIn = () => {
    setScale(prevScale => Math.min(prevScale + 0.1, 2));
  };

  // Handle zoom out
  const handleZoomOut = () => {
    setScale(prevScale => Math.max(prevScale - 0.1, 0.5));
  };

  // ── NEW: Preview dialog handlers (same logic as ContactForm) ───────────────
  const handleOpenPreview = () => {
    setPreviewScale(isMobile ? 0.46 : 0.85);
    setOpenPreviewDialog(true);
  };

  const handleClosePreview = () => {
    setOpenPreviewDialog(false);
  };
  // ─────────────────────────────────────────────────────────────────────────────

  // Helper function to darken colors
  const getDarkColor = (hex) => {
    if (!hex || typeof hex !== "string") return "#000000";
    let c = hex.replace("#", "");
    if (c.length === 8) c = c.slice(0, 6);
    let r = Math.max(0, parseInt(c.substring(0, 2), 16) - 40);
    let g = Math.max(0, parseInt(c.substring(2, 4), 16) - 40);
    let b = Math.max(0, parseInt(c.substring(4, 6), 16) - 40);
    return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
  };
  
  // State for resume data
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    currentPosition:"",
    city: "",
    country: "India",
    pinCode: "",
    phone: "",
    email: "",
    linkedIn: "",
    website: "",
    drivingLicence: "",
  });
  const [workExperiences, setWorkExperiences] = useState([]);
  const [preview, setPreview] = useState("");
  
  // Function to get props for the selected resume template
  const getResumeProps = () => {
    switch (selectedTemplate) {
      case 2:
        return { 
          color: designSettings.color, 
          workExperiences, 
          formData, 
          photo: preview,
          exporting
        };
      case 3:
        return { 
          color: typeof designSettings.color === "object" ? designSettings.color.primary : designSettings.color, 
          workExperiences, 
          formData, 
          photo: preview,
          exporting
        };
      case 4:
        return { 
          theme: designSettings.color, 
          color: typeof designSettings.color === "object" ? designSettings.color.primary : designSettings.color, 
          workExperiences, 
          formData, 
          photo: preview,
          exporting
        };
      case 7:
        return { 
          theme: designSettings.color, 
          color: typeof designSettings.color === "object" ? designSettings.color.highlight : designSettings.color, 
          workExperiences, 
          formData, 
          photo: preview,
          exporting
        };
      case 8:
        return { 
          theme: designSettings.color, 
          workExperiences, 
          formData, 
          photo: preview,
          exporting
        };
      default:
        return { 
          color: designSettings.color, 
          workExperiences, 
          formData, 
          photo: preview,
          exporting
        };
    }
  };

  // Fetch data
  useEffect(() => {
    const savedWorks = localStorage.getItem("workExperiences");
    if (savedWorks) {
      setWorkExperiences(JSON.parse(savedWorks));
    }

    const fetchContactData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const res = await axios.get("https://resume-maker-lc.onrender.com/api/contact/me", {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data) {
          setFormData({
            firstName: res.data.firstName || "",
            lastName: res.data.lastName || "",
            currentPosition: res.data.currentPosition || "",
            city: res.data.city || "",
            country: res.data.country || "India",
            pinCode: res.data.pinCode || "",
            phone: res.data.phone || "",
            email: res.data.email || "",
            linkedIn: res.data.linkedIn || "",
            website: res.data.website || "",
            drivingLicence: res.data.drivingLicence || "",
          });

          if (res.data.photo) {
            setPreview(
              res.data.photo.startsWith("http")
                ? res.data.photo
                : `https://resume-maker-lc.onrender.com${res.data.photo}`
            );
          }
        }
      } catch (err) {
        console.error("Error fetching contact", err);
      }
    };

    const fetchSummaryData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const res = await axios.get("https://resume-maker-lc.onrender.com/api/summary/all", {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data && Array.isArray(res.data)) {
          const descriptions = res.data.map((s) => s.description);
          localStorage.setItem("summaries", JSON.stringify(descriptions));
        }
      } catch (err) {
        console.error("Error fetching summaries in editor", err);
      }
    };

    fetchContactData();
    fetchSummaryData();
  }, []);

  // Handle Finish button click
  const handleFinishClick = () => {
    setFinishDialogOpen(true);
  };

  // Handle navigation to My Account page
  const handleGoToMyAccount = () => {
    setFinishDialogOpen(false);
    navigate("/myaccount");
  };

  // Handle navigation to Home page
  const handleGoToHome = () => {
    navigate("/");
  };

  // Handle navigation to ExtraSection page (Back Arrow)
  const handleGoToExtraSection = () => {
    navigate("/ExtraSection");
  };

  // Shared resume component props (used both in editor view and preview dialog)
  const sharedResumeProps = {
    ...getResumeProps(),
    theme: { 
      primary: designSettings.color, 
      dark: getDarkColor(
        typeof designSettings.color === "string"
          ? designSettings.color
          : designSettings.color?.primary || "#0951b0"
      )
    },
    color: designSettings.color,
    font: designSettings.font,
    fontSize: designSettings.fontSize,
    fontStyle: designSettings.fontStyle,
    headingSize: designSettings.headingSize,
    sectionSpacing: designSettings.sectionSpacing,
    paragraphSpacing: designSettings.paragraphSpacing,
    lineSpacing: designSettings.lineSpacing,
    topBottomMargin: designSettings.topBottomMargin,
    sideMargins: designSettings.sideMargins,
    paragraphIndent: designSettings.paragraphIndent,
    lineWeight: designSettings.lineWeight,
    pageSize: designSettings.pageSize,
  };

  // Render Middle Content
  const renderContent = () => {
    const SelectedResumeComponent = templateComponents[selectedTemplate] || Resume1;
    
    if (isMobile) {
      return (
        <Box display="flex" flexDirection="column" height="100%">
          {/* Mobile Edit/Preview Tabs */}
          <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', bgcolor: '#fff', mb: 1 }}>
            <Button 
              fullWidth 
              variant={mobileViewTab === 0 ? "contained" : "text"}
              onClick={() => setMobileViewTab(0)}
              sx={{ 
                py: 1, 
                borderRadius: 0,
                fontWeight: "bold",
                background: mobileViewTab === 0 ? "#002B5B" : "none",
                color: mobileViewTab === 0 ? "#fff" : "#666",
                "&:hover": {
                  background: mobileViewTab === 0 ? "#0288D1" : "none",
                }
              }}
            >
              ✍️ Edit Form
            </Button>
            <Button 
              fullWidth 
              variant={mobileViewTab === 1 ? "contained" : "text"}
              onClick={() => setMobileViewTab(1)}
              sx={{ 
                py: 1, 
                borderRadius: 0,
                fontWeight: "bold",
                background: mobileViewTab === 1 ? "#002B5B" : "none",
                color: mobileViewTab === 1 ? "#fff" : "#666",
                "&:hover": {
                  background: mobileViewTab === 1 ? "#0288D1" : "none",
                }
              }}
            >
              👁️ Live Preview
            </Button>
          </Box>

          <Box flex={1} sx={{ overflowY: "auto", display: mobileViewTab === 0 ? "block" : "none" }}>
            {(() => {
              switch (selectedMenu) {
                case "templates":
                  return (
                    <TemplatesComponent 
                      selectedTemplate={selectedTemplate}
                      setSelectedTemplate={handleTemplateSelect}
                      selectedColor={designSettings.color}
                      setSelectedColor={(color) => setDesignSettings({...designSettings, color})}
                    />
                  );
                case "design":
                  return (
                    <DesignFormattingComponent 
                      designSettings={designSettings}
                      setDesignSettings={setDesignSettings}
                    />
                  );
                case "add":
                  return <AddSectionComponent />;
                case "spell":
                  return <SpellCheckComponent 
                    resumeContent={resumeContent} 
                    appliedCorrections={appliedCorrections}
                    setAppliedCorrections={setAppliedCorrections}
                  />;
                default:
                  return (
                    <DesignFormattingComponent 
                      designSettings={designSettings}
                      setDesignSettings={setDesignSettings}
                    />
                  );
              }
            })()}
          </Box>

          <Box 
            flex={1}
            p={1} 
            sx={{ 
              overflowY: "auto", 
              overflowX: "hidden",
              display: mobileViewTab === 1 ? "flex" : "none",
              justifyContent: "center",
              alignItems: "flex-start",
              bgcolor: "#EFF7FF",
            }}
          >
            <Box 
              id="resume-preview" 
              sx={{ 
                transform: `scale(${scale * 0.45})`,
                transformOrigin: "top center",
                transition: "transform 0.2s ease-in-out",
                width: "794px",
                mb: `calc(-1123px * (1 - ${scale * 0.45}))`,
                position: "relative",
              }}
            >
              <SelectedResumeComponent {...sharedResumeProps} />
            </Box>
          </Box>
        </Box>
      );
    }

    return (
      <Box display="flex" height="100%">
        <Box 
          width="380px" 
          p={3} 
          sx={{ 
            overflowY: "auto", 
            flexShrink: 0,
            borderRight: "1px solid #B3D9F7",
            bgcolor: "#ffffff",
            scrollbarWidth: "thin"
          }}
        >
          {(() => {
            switch (selectedMenu) {
              case "templates":
                return (
                  <TemplatesComponent 
                    selectedTemplate={selectedTemplate}
                    setSelectedTemplate={handleTemplateSelect}
                    selectedColor={designSettings.color}
                    setSelectedColor={(color) => setDesignSettings({...designSettings, color})}
                    setDesignSettings={setDesignSettings}
                  />
                );
              case "design":
                return (
                  <DesignFormattingComponent 
                    designSettings={designSettings}
                    setDesignSettings={setDesignSettings}
                  />
                );
              case "add":
                return <AddSectionComponent />;
              case "spell":
                return <SpellCheckComponent 
                  resumeContent={resumeContent} 
                  appliedCorrections={appliedCorrections}
                  setAppliedCorrections={setAppliedCorrections}
                />;
              default:
                return (
                  <DesignFormattingComponent 
                    designSettings={designSettings}
                    setDesignSettings={setDesignSettings}
                  />
                );
            }
          })()}
        </Box>

        <Box 
          flex={1} 
          p={4} 
          sx={{ 
            overflow: "auto", 
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            bgcolor: "#EFF7FF",
            scrollbarWidth: "thin"
          }}
        >
          <Box 
            id="resume-preview" 
            sx={{ 
              transform: `scale(${scale})`,
              transformOrigin: "top center",
              transition: "transform 0.2s ease-in-out",
              width: "100%",
              position: "relative",
            }}
          >
            <SelectedResumeComponent {...sharedResumeProps} />
          </Box>
        </Box>
      </Box>
    );
  };

  // Sidebar button styles
  const verticalButtonStyles = {
    borderRadius: "12px",
    mb: 1,
    py: 1.5,
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    transition: "all 0.2s ease-in-out",
    "& .MuiListItemIcon-root": { 
      minWidth: "auto", 
      mb: 0.75,
      color: "#002B5B",
      transition: "color 0.2s ease-in-out"
    },
    "&:hover": {
      bgcolor: "#EFF7FF",
      "& .MuiListItemIcon-root": { color: "#0288D1" },
    },
    "&.Mui-selected": {
      bgcolor: "#B3D9F7",
      color: "#002B5B",
      "& .MuiListItemIcon-root": { color: "#002B5B" },
      "&:hover": {
        bgcolor: "#B3D9F7",
      }
    },
  };

  const SelectedResumeComponent = templateComponents[selectedTemplate] || Resume1;

  return (
    <Box display="flex" flexDirection="column" height="100vh" sx={{ overflow: "hidden", bgcolor: "#EFF7FF" }}>
      <AppBar 
        position="static" 
        elevation={0} 
        sx={{ 
          bgcolor: "rgba(255, 255, 255, 0.85)", 
          backdropFilter: "blur(20px)", 
          color: "#002B5B", 
          borderBottom: "1px solid #B3D9F7",
          zIndex: 1100
        }}
      >
        <Toolbar sx={{ minHeight: 48, px: 2, display: "flex", justifyContent: "space-between" }}>
          {/* Left: Home Icon + Back + Name */}
          <Box display="flex" alignItems="center">
            {/* Home Icon - Navigates to / */}
            <IconButton 
              edge="start" 
              color="inherit" 
              onClick={handleGoToHome}
              sx={{ mr: 0.5 }}
              aria-label="home"
            >
              <Home />
            </IconButton>

            {/* Back Arrow - Navigates to /ExtraSection */}
            <IconButton 
              edge="start" 
              color="inherit" 
              onClick={handleGoToExtraSection}
              sx={{ mr: 1 }}
              aria-label="back"
            >
              <ArrowBack />
            </IconButton>
            
            <Typography variant="h6" sx={{ fontSize: { xs: "1.1rem", sm: "1.25rem" }, fontWeight: "bold", display: "flex", alignItems: "center", gap: 1, color: "#002B5B" }}>
              📝 {resumeName}
              {/* Rename button - renamed from "Edit" to "Rename" */}
              <Button 
                size="small" 
                variant="contained" 
                onClick={() => setResumeNameDialogOpen(true)} 
                sx={{ 
                  fontSize: { xs: "0.55rem", sm: "0.65rem" },
                  padding: { xs: "1px 8px", sm: "2px 10px" }, 
                  minWidth: "auto",
                  borderRadius: "4px",
                  backgroundColor: "#002B5B",
                  color: "#ffffff",
                  textTransform: "none",
                  fontWeight: 600,
                  boxShadow: "none",
                  '&:hover': {
                    backgroundColor: "#0288D1",
                    boxShadow: "none"
                  }
                }}
              >
                Rename
              </Button>
            </Typography>
          </Box>

          {/* Center (Desktop only): Zoom Controls */}
          {!isMobile && (
            <Box display="flex" alignItems="center" gap={1} sx={{ bgcolor: "#EFF7FF", px: 2, py: 0.5, borderRadius: "20px", border: "1px solid #B3D9F7" }}>
              <IconButton 
                size="small" 
                onClick={handleZoomOut} 
                disabled={scale <= 0.5}
                sx={{ p: 0.5, color: "#002B5B", "&:hover": { color: "#0288D1" } }}
              >
                <ZoomOut fontSize="small" />
              </IconButton>
              <Typography variant="body2" sx={{ fontWeight: "bold", minWidth: "45px", textAlign: "center", color: "#002B5B" }}>
                {Math.round(scale * 100)}%
              </Typography>
              <IconButton 
                size="small" 
                onClick={handleZoomIn} 
                disabled={scale >= 2}
                sx={{ p: 0.5, color: "#002B5B", "&:hover": { color: "#0288D1" } }}
              >
                <ZoomIn fontSize="small" />
              </IconButton>
            </Box>
          )}

          {/* Right: Actions */}
          <Box display="flex" alignItems="center" gap={1.5}>
            {misspelledWords.length > 0 && selectedMenu !== "spell" && !isMobile && (
              <Alert severity="error" sx={{ py: 0, mr: 2, display: "flex", alignItems: "center" }}>
                {misspelledWords.length} errors
              </Alert>
            )}

            {!isMobile && (
              <>
                {/* ── NEW: Preview button in AppBar (desktop) ── */}
                <Button
                  variant="outlined"
                  startIcon={<Visibility fontSize="small" />}
                  onClick={handleOpenPreview}
                  size="small"
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    borderColor: "#002B5B",
                    color: "#002B5B",
                    borderRadius: 2,
                    "&:hover": {
                      borderColor: "#0288D1",
                      backgroundColor: "rgba(2, 136, 209, 0.06)",
                      color: "#0288D1",
                    },
                  }}
                >
                  Preview
                </Button>

                <IconButton 
                  color="primary" 
                  onClick={handlePrint}
                  disabled={exporting}
                  sx={{ bgcolor: "#EFF7FF", color: "#002B5B", "&:hover": { bgcolor: "#B3D9F7", color: "#0288D1" } }}
                >
                  <Print fontSize="small" />
                </IconButton>

                <IconButton 
                  color="primary" 
                  onClick={() => setDownloadDialogOpen(true)}
                  disabled={exporting}
                  sx={{ bgcolor: "#EFF7FF", color: "#002B5B", "&:hover": { bgcolor: "#B3D9F7", color: "#0288D1" } }}
                >
                  <Download fontSize="small" />
                </IconButton>

                <Button 
                  variant="contained" 
                  color="secondary" 
                  size="small"
                  sx={{ 
                    borderRadius: "30px", 
                    px: 3,
                    py: 0.75,
                    background: "#002B5B",
                    color: "white",
                    fontWeight: "bold",
                    textTransform: "none",
                    boxShadow: "0 4px 12px rgba(0,43,91,0.2)",
                    "&:hover": {
                      background: "#0288D1",
                      boxShadow: "0 6px 16px rgba(2,136,209,0.3)",
                    }
                  }}
                  onClick={handleFinishClick}
                >
                  Finish
                </Button>
              </>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      <Box display="flex" flexDirection={{ xs: "column", md: "row" }} flex={1} sx={{ height: "calc(100vh - 48px)", overflow: "hidden" }}>
        {/* Left Bottom-Tab / Desktop Left-Sidebar */}
        <Box 
          sx={{ 
            width: { xs: "100%", md: "80px" }, 
            bgcolor: "#EFF7FF", 
            p: { xs: 1, md: 1.5 }, 
            borderRight: { xs: "none", md: "1px solid #B3D9F7" },
            borderTop: { xs: "1px solid #B3D9F7", md: "none" },
            display: "flex",
            flexDirection: { xs: "row", md: "column" },
            justifyContent: { xs: "space-around", md: "flex-start" },
            alignItems: "center",
            order: { xs: 2, md: 0 },
          }}
        >
          {!isMobile && <Typography variant="caption" sx={{ ml: 1, mt: 2, color: "#002B5B" }}>CUSTOMIZE</Typography>}
          <List sx={{ display: "flex", flexDirection: { xs: "row", md: "column" }, gap: { xs: 1, md: 0 }, width: { xs: "100%", md: "auto" }, justifyContent: "space-around", p: 0, m: 0 }}>
            <ListItemButton selected={selectedMenu === "templates"} onClick={() => setSelectedMenu("templates")} sx={{ ...verticalButtonStyles, mb: { xs: 0, md: 1 } }}>
              <ListItemIcon><FaFileAlt size={20} /></ListItemIcon>
              <ListItemText primary="Templates" primaryTypographyProps={{ fontSize: "0.75rem", color: "#002B5B" }} />
            </ListItemButton>
            <ListItemButton selected={selectedMenu === "design"} onClick={() => setSelectedMenu("design")} sx={{ ...verticalButtonStyles, mb: { xs: 0, md: 1 } }}>
              <ListItemIcon><MdOutlineDesignServices size={22} /></ListItemIcon>
              <ListItemText primary="Design" primaryTypographyProps={{ fontSize: "0.75rem", color: "#002B5B" }} />
            </ListItemButton>
            {isMobile && (
              <>
                <ListItemButton selected={selectedMenu === "add"} onClick={() => setSelectedMenu("add")} sx={{ ...verticalButtonStyles, mb: 0 }}>
                  <ListItemIcon><MdFormatListBulletedAdd size={22} /></ListItemIcon>
                  <ListItemText primary="Add" primaryTypographyProps={{ fontSize: "0.75rem", color: "#002B5B" }} />
                </ListItemButton>
                <ListItemButton 
                  selected={selectedMenu === "spell"} 
                  onClick={() => setSelectedMenu("spell")} 
                  sx={{
                    ...verticalButtonStyles,
                    mb: 0,
                    ...(misspelledWords.length > 0 && { color: 'error.main' })
                  }}
                >
                  <ListItemIcon>
                    <MdSpellcheck size={22} color={misspelledWords.length > 0 ? 'error' : '#002B5B'} />
                  </ListItemIcon>
                  <ListItemText 
                    primary="Spell" 
                    primaryTypographyProps={{ 
                      fontSize: "0.75rem",
                      color: misspelledWords.length > 0 ? 'error.main' : '#002B5B'
                    }} 
                  />
                  {misspelledWords.length > 0 && (
                    <Chip 
                      label={misspelledWords.length} 
                      size="small" 
                      color="error" 
                      sx={{ position: 'absolute', top: 4, right: 4, height: 16, minWidth: 16 }} 
                    />
                  )}
                </ListItemButton>
              </>
            )}
          </List>
          
          {!isMobile && (
            <>
              <Typography variant="caption" sx={{ ml: 1, mt: 2, color: "#002B5B" }}>TOOLS</Typography>
              <List>
                <ListItemButton selected={selectedMenu === "add"} onClick={() => setSelectedMenu("add")} sx={verticalButtonStyles}>
                  <ListItemIcon><MdFormatListBulletedAdd size={22} /></ListItemIcon>
                  <ListItemText primary="Add" primaryTypographyProps={{ fontSize: "0.75rem", color: "#002B5B" }} />
                </ListItemButton>
                <ListItemButton 
                  selected={selectedMenu === "spell"} 
                  onClick={() => setSelectedMenu("spell")} 
                  sx={{
                    ...verticalButtonStyles,
                    ...(misspelledWords.length > 0 && { color: 'error.main' })
                  }}
                >
                  <ListItemIcon>
                    <MdSpellcheck size={22} color={misspelledWords.length > 0 ? 'error' : '#002B5B'} />
                  </ListItemIcon>
                  <ListItemText 
                    primary="Spell" 
                    primaryTypographyProps={{ 
                      fontSize: "0.75rem",
                      color: misspelledWords.length > 0 ? 'error.main' : '#002B5B'
                    }} 
                  />
                  {misspelledWords.length > 0 && (
                    <Chip 
                      label={misspelledWords.length} 
                      size="small" 
                      color="error" 
                      sx={{ position: 'absolute', top: 4, right: 4, height: 16, minWidth: 16 }} 
                    />
                  )}
                </ListItemButton>
              </List>
            </>
          )}
        </Box>

        {/* Middle Main Content Panel */}
        <Box 
          sx={{ 
            flex: 1,
            p: 1,
            height: { xs: "auto", md: "100%" },
            overflow: "hidden",
            order: { xs: 1, md: 1 },
            bgcolor: "#EFF7FF",
          }}
        >
          {renderContent()}
        </Box>

        {/* ================================================================
            RIGHT TOP-ACTIONS-ROW / MOBILE TOOLBAR
            ================================================================ */}
        <Box 
          sx={{ 
            width: { xs: "100%", md: "120px" }, 
            bgcolor: "#EFF7FF",
            display: { xs: "flex", md: "none" }, 
            flexDirection: { xs: "row", md: "column" }, 
            alignItems: "center", 
            justifyContent: { xs: "space-around", md: "flex-start" },
            borderLeft: { xs: "none", md: "1px solid #B3D9F7" }, 
            borderBottom: { xs: "1px solid #B3D9F7", md: "none" },
            p: { xs: 1, md: 2 },
            gap: { xs: 1, md: 2 },
            overflowX: { xs: "auto", md: "visible" },
            whiteSpace: "nowrap",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
            order: { xs: 0, md: 2 },
          }}
        >
          {/* Zoom Controls */}
          <Box display="flex" flexDirection={{ xs: "row", md: "column" }} alignItems="center" gap={1} mb={{ xs: 0, md: 2 }}>
            {!isMobile && <Typography variant="caption" sx={{ mb: 1 }}>Zoom: {Math.round(scale * 100)}%</Typography>}
            <Box display="flex" gap={0.5} alignItems="center">
              <IconButton 
                size="small" 
                onClick={handleZoomOut} 
                disabled={scale <= 0.5}
                sx={{ border: "1px solid #B3D9F7", p: 0.5, color: "#002B5B", "&:hover": { color: "#0288D1" } }}
              >
                <ZoomOut fontSize="small" />
              </IconButton>
              {isMobile && <Typography variant="caption" sx={{ alignSelf: "center", mx: 0.5, color: "#002B5B" }}>{Math.round(scale * 100)}%</Typography>}
              <IconButton 
                size="small" 
                onClick={handleZoomIn} 
                disabled={scale >= 2}
                sx={{ border: "1px solid #B3D9F7", p: 0.5, color: "#002B5B", "&:hover": { color: "#0288D1" } }}
              >
                <ZoomIn fontSize="small" />
              </IconButton>
            </Box>
          </Box>

          {/* Preview Icon */}
          <Box display="flex" flexDirection={{ xs: "row", md: "column" }} alignItems="center" mb={{ xs: 0, md: 2 }}>
            <IconButton
              color="primary"
              onClick={handleOpenPreview}
              size={isMobile ? "small" : "medium"}
              sx={{ color: "#002B5B", "&:hover": { color: "#0288D1" } }}
            >
              <Visibility fontSize={isMobile ? "small" : "medium"} />
            </IconButton>
            {!isMobile && <Typography variant="caption" sx={{ color: "#002B5B" }}>Preview</Typography>}
          </Box>

          {/* Download Icon */}
          <Box display="flex" flexDirection={{ xs: "row", md: "column" }} alignItems="center" mb={{ xs: 0, md: 2 }}>
            <IconButton
              color="primary"
              onClick={() => setDownloadDialogOpen(true)}
              disabled={exporting}
              size={isMobile ? "small" : "medium"}
              sx={{ color: "#002B5B", "&:hover": { color: "#0288D1" } }}
            >
              <Download fontSize={isMobile ? "small" : "medium"} />
            </IconButton>
            {!isMobile && <Typography variant="caption" sx={{ color: "#002B5B" }}>{exporting ? "Wait..." : "Download"}</Typography>}
          </Box>

          {/* Print Icon */}
          <Box display="flex" flexDirection={{ xs: "row", md: "column" }} alignItems="center" mb={{ xs: 0, md: 2 }}>
            <IconButton
              color="primary"
              onClick={handlePrint}
              disabled={exporting}
              size={isMobile ? "small" : "medium"}
              sx={{ color: "#002B5B", "&:hover": { color: "#0288D1" } }}
            >
              <Print fontSize={isMobile ? "small" : "medium"} />
            </IconButton>
            {!isMobile && <Typography variant="caption" sx={{ color: "#002B5B" }}>Print</Typography>}
          </Box>

          {/* Finish Button */}
          <Button 
            variant="contained" 
            color="secondary" 
            size={isMobile ? "small" : "medium"}
            sx={{ 
              mt: { xs: 0, md: 3 }, 
              borderRadius: "30px", 
              px: { xs: 2, md: 3 },
              py: { xs: 0.5, md: 1 },
              background: "#002B5B",
              color: "white",
              fontWeight: "bold",
              fontSize: { xs: "0.75rem", md: "0.875rem" },
              textTransform: "none",
              "&:hover": {
                background: "#0288D1",
                boxShadow: "0 4px 15px rgba(2, 136, 209, 0.4)",
              }
            }}
            onClick={handleFinishClick}
          >
            Finish
          </Button>
        </Box>
        {/* ================================================================ */}
      </Box>

      {/* ══════════════════════════════════════════════════════════════════════
          NEW: Preview Dialog — identical behaviour to ContactForm's preview
          ══════════════════════════════════════════════════════════════════════ */}
      <Dialog
        open={openPreviewDialog}
        onClose={handleClosePreview}
        maxWidth="lg"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            borderRadius: { xs: 0, sm: 2 },
            maxHeight: { xs: "100vh", sm: "90vh" },
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#002B5B",
            borderBottom: "1px solid #0288D1",
            py: 2,
            px: 3,
          }}
        >
          <Typography variant="h6" fontWeight="bold" sx={{ color: "#FFFFFF" }}>
            Resume Preview
          </Typography>

          {/* Zoom controls inside the preview dialog */}
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            sx={{
              bgcolor: "#fff",
              px: 2,
              py: 0.5,
              borderRadius: "20px",
              border: "1px solid #B3D9F7",
            }}
          >
            <IconButton
              size="small"
              onClick={() => setPreviewScale(prev => Math.max(0.3, prev - 0.1))}
              disabled={previewScale <= 0.3}
              sx={{ p: 0.5, color: "#002B5B", "&:hover": { color: "#0288D1" } }}
            >
              <ZoomOut fontSize="small" />
            </IconButton>
            <Typography
              variant="body2"
              sx={{ fontWeight: "bold", minWidth: "45px", textAlign: "center", color: "#002B5B" }}
            >
              {Math.round(previewScale * 100)}%
            </Typography>
            <IconButton
              size="small"
              onClick={() => setPreviewScale(prev => Math.min(2.0, prev + 0.1))}
              disabled={previewScale >= 2.0}
              sx={{ p: 0.5, color: "#002B5B", "&:hover": { color: "#0288D1" } }}
            >
              <ZoomIn fontSize="small" />
            </IconButton>
          </Box>

          <IconButton
            onClick={handleClosePreview}
            size="small"
            sx={{
              color: "#FFFFFF",
              "&:hover": { color: "#B3D9F7", backgroundColor: "rgba(179, 217, 247, 0.1)" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            padding: { xs: 1, sm: 4 },
            overflow: "auto",
            backgroundColor: "#EFF7FF",
          }}
        >
          <Box
            sx={{
              width: "800px",
              flexShrink: 0,
              transform: `scale(${previewScale})`,
              transformOrigin: "top center",
              transition: "transform 0.2s ease-in-out",
              marginLeft: `calc((800px * ${previewScale} - 800px) / 2)`,
              marginRight: `calc((800px * ${previewScale} - 800px) / 2)`,
              marginBottom: `calc((800px * ${previewScale} - 800px) / 2)`,
              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
              borderRadius: 1,
              backgroundColor: "white",
            }}
          >
            <SelectedResumeComponent {...sharedResumeProps} />
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            padding: 3,
            backgroundColor: "#EFF7FF",
            borderTop: "1px solid #B3D9F7",
          }}
        >
          <Button
            onClick={handleClosePreview}
            variant="contained"
            fullWidth={isMobile}
            sx={{
              backgroundColor: "#002B5B",
              "&:hover": { backgroundColor: "#0288D1" },
              fontWeight: "bold",
              borderRadius: 2,
              px: 4,
              py: 1,
            }}
          >
            Close Preview
          </Button>
        </DialogActions>
      </Dialog>
      {/* ══════════════════════════════════════════════════════════════════════ */}

      {/* Download Dialog */}
      <Dialog
        open={downloadDialogOpen}
        onClose={() => !exporting && setDownloadDialogOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ color: "#002B5B", fontWeight: "bold" }}>Download Resume</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="File Name"
            value={fileName}
            onChange={(e) => setFileName(e.target.value)}
            sx={{ my: 2 }}
            disabled={exporting}
            InputProps={{
              sx: {
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#B3D9F7" },
                  "&:hover fieldset": { borderColor: "#B3D9F7" },
                  "&.Mui-focused fieldset": { borderColor: "#002B5B" },
                },
              },
            }}
          />
          <RadioGroup value={fileFormat} onChange={(e) => setFileFormat(e.target.value)}>
            <FormControlLabel 
              value="pdf" 
              control={<Radio disabled={exporting} sx={{ color: "#B3D9F7", '&.Mui-checked': { color: "#002B5B" } }} />} 
              label="PDF (.pdf)" 
            />
            <FormControlLabel 
              value="png" 
              control={<Radio disabled={exporting} sx={{ color: "#B3D9F7", '&.Mui-checked': { color: "#002B5B" } }} />} 
              label="PNG (.png)" 
            />
            <FormControlLabel 
              value="docx" 
              control={<Radio disabled={exporting} sx={{ color: "#B3D9F7", '&.Mui-checked': { color: "#002B5B" } }} />} 
              label="Word (.docx)" 
            />
            <FormControlLabel 
              value="doc" 
              control={<Radio disabled={exporting} sx={{ color: "#B3D9F7", '&.Mui-checked': { color: "#002B5B" } }} />} 
              label="Word (.doc)" 
            />
          </RadioGroup>
          {exporting && (
            <Typography variant="body2" color="primary" sx={{ mt: 1, color: "#0288D1" }}>
              ⏳ Generating your file, please wait…
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ display: "flex", flexDirection: "row", gap: 2, px: 3, pb: 3 }}>
          <Button
            onClick={() => setDownloadDialogOpen(false)}
            disabled={exporting}
            sx={{
              borderRadius: "12px",
              px: 3,
              py: 1.5,
              textTransform: "none",
              borderColor: "#002B5B",
              color: "#002B5B",
              fontWeight: "bold",
              width: "50%",
              "&:hover": {
                borderColor: "#0288D1",
                color: "#0288D1",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => handleDownload(fileFormat)}
            disabled={exporting}
            sx={{
              background: "#002B5B",
              color: "#fff",
              fontWeight: "bold",
              px: 3,
              py: 1.5,
              borderRadius: "12px",
              width: "50%",
              "&:hover": {
                background: "#0288D1",
              },
            }}
          >
            {exporting ? "Processing…" : "Download"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Resume Name Dialog */}
      <Dialog open={resumeNameDialogOpen} onClose={() => setResumeNameDialogOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle sx={{ color: "#002B5B", fontWeight: "bold" }}>Edit Resume Name</DialogTitle>
        <DialogContent>
          <TextField 
            fullWidth 
            label="Resume Name" 
            value={resumeName} 
            onChange={(e) => setResumeName(e.target.value)} 
            sx={{ my: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setResumeNameDialogOpen(false)} sx={{ color: "#002B5B" }}>
                    <Title />
                  </IconButton>
                </InputAdornment>
              ),
              sx: {
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#B3D9F7" },
                  "&:hover fieldset": { borderColor: "#B3D9F7" },
                  "&.Mui-focused fieldset": { borderColor: "#002B5B" },
                },
              },
            }}
          />
        </DialogContent>
        <DialogActions sx={{ display: "flex", flexDirection: "row", gap: 2, px: 3, pb: 3 }}>
          <Button 
            onClick={() => setResumeNameDialogOpen(false)} 
            sx={{
              borderRadius: "12px",
              px: 3,
              py: 1.5,
              textTransform: "none",
              borderColor: "#002B5B",
              color: "#002B5B",
              fontWeight: "bold",
              width: "50%",
              "&:hover": {
                borderColor: "#0288D1",
                color: "#0288D1",
              },
            }}
          >
            Cancel
          </Button>
          <Button 
            variant="contained" 
            onClick={() => setResumeNameDialogOpen(false)} 
            sx={{
              background: "#002B5B",
              color: "#fff",
              fontWeight: "bold",
              px: 3,
              py: 1.5,
              borderRadius: "12px",
              width: "50%",
              "&:hover": {
                background: "#0288D1",
              },
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Finish Success Dialog */}
      <Dialog 
        open={finishDialogOpen} 
        onClose={() => setFinishDialogOpen(false)} 
        fullWidth 
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            overflow: "hidden",
          }
        }}
      >
        <DialogTitle sx={{ 
          textAlign: "center", 
          bgcolor: "#002B5B", 
          color: "white",
          py: 3,
        }}>
          <CheckCircle sx={{ fontSize: 60, mb: 1 }} />
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            🎉 Congratulations!
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center", py: 4, bgcolor: "#EFF7FF" }}>
          <Typography variant="h6" sx={{ mb: 2, color: "#002B5B" }}>
            Your Resume Template Completed Successfully!
          </Typography>
          <Typography variant="body1" sx={{ color: "#0D4C8B", mb: 3 }}>
            Your professional resume has been created with Template #{selectedTemplate}. 
            You can now view it in your account or continue editing.
          </Typography>
          <Box sx={{ 
            display: "flex", 
            flexDirection: "column", 
            alignItems: "center",
            gap: 2,
            mt: 3,
          }}>
            <Typography variant="body2" sx={{ color: "#0D4C8B" }}>
              Where would you like to go?
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ 
          display: "flex", 
          flexDirection: "column", 
          gap: 2, 
          px: 3, 
          pb: 3,
          pt: 2,
          bgcolor: "#EFF7FF",
        }}>
          {/* Go to My Account Page Button */}
          <Button 
            variant="contained" 
            fullWidth
            onClick={handleGoToMyAccount}
            sx={{
              background: "#002B5B",
              color: "white",
              fontWeight: "bold",
              py: 1.5,
              borderRadius: "12px",
              fontSize: "1rem",
              "&:hover": {
                background: "#0288D1",
                boxShadow: "0 4px 15px rgba(2, 136, 209, 0.4)",
              }
            }}
          >
            👤 Go to My Account Page
          </Button>

          {/* Go to Home Page Button - NEW */}
          <Button 
            variant="contained" 
            fullWidth
            onClick={handleGoToHome}
            sx={{
              background: "#0288D1",
              color: "white",
              fontWeight: "bold",
              py: 1.5,
              borderRadius: "12px",
              fontSize: "1rem",
              "&:hover": {
                background: "#002B5B",
                boxShadow: "0 4px 15px rgba(0, 43, 91, 0.4)",
              }
            }}
          >
            🏠 Go to Home Page
          </Button>

          <Button 
            onClick={() => setFinishDialogOpen(false)}
            sx={{
              color: "#002B5B",
              fontWeight: "500",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "rgba(0, 43, 91, 0.04)",
              }
            }}
          >
            Continue Editing
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ResumeEditor;